import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
  constructor() {}

  public YYYYMMDDFormat(date: Date) {
    if (!date) {
      return
    }
    const offset = date.getTimezoneOffset();    
    date = new Date(date.getTime() - offset * 60 * 1000);    
    const formattedDate = date
      .toISOString()
      .replace('T', ' ')
      .replace(/\..*/, '');
    return formattedDate;
  }
}
